import { render, staticRenderFns } from "./PremiumInvoiceDetail.vue?vue&type=template&id=3103a820"
import script from "./PremiumInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./PremiumInvoiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports